export enum QueryParams {
    buildingId = 'buildingId',
    nodeFrom = 'nodeFrom',
    nodeTo = 'nodeTo',
    routeLang = 'routeLang',
    WheelChair = 'WheelChair',
    MultiBuilding = 'MultiBuilding'
}